import { useEffect } from "react";
import { selectUsernamesToFetch } from "selectors/User";
import { fetchUsernames } from "app/slices/UsersSlice";
import { useAppDispatch, useAppSelector } from "app/hooks";

export const useFetchUsernames = (uids: string[]) => {
  const dispatch = useAppDispatch();
  const usernamesToFetch = useAppSelector((state) =>
    selectUsernamesToFetch(state, uids)
  );

  useEffect(() => {
    if (usernamesToFetch.length > 0) {
      dispatch(fetchUsernames(usernamesToFetch));
    }
  }, [usernamesToFetch]);
};
